import { useEffect } from 'react';
import { applyStrokeScale } from '../utils/canvasViewport';

/**
 * Keeps annotation strokes at a constant on-screen width as the zoom changes,
 * so a box is never a hairline on a small image or a fat band on a large one.
 */
const useStrokeWidthUpdater = (canvas, images, zoomLevel, BASE_STROKE_WIDTH) => {
  useEffect(() => {
    if (!canvas || images.length === 0) return;
    applyStrokeScale(canvas, zoomLevel, BASE_STROKE_WIDTH);
    canvas.requestRenderAll();
  }, [canvas, zoomLevel, images, BASE_STROKE_WIDTH]);
};

export default useStrokeWidthUpdater;
